export default "__VITE_ASSET__OvhVpYkT__"